<template>
  <div class="doc-type" :class="{ 'is-upload': isUpload, 'is-locked': disabled, 'has-delete': deletable }">
    <button
      type="button"
      class="doc-type-main"
      :disabled="disabled || isGenerating"
      :title="disabled ? 'ใช้ได้กับแพ็ก BASIC, PRO และ PREMIUM' : title"
      @click="handleGenerate"
    >
      <i v-if="isUpload" class="fas fa-plus doc-type-icon" aria-hidden="true"></i>
      <span class="doc-type-title">{{ title }}</span>
      <b-spinner v-if="isGenerating" small class="doc-type-spinner" label="กำลังสร้าง" />
      <span v-else-if="disabled" class="doc-type-lock">
        <i class="fas fa-lock" aria-hidden="true"></i> BASIC ขึ้นไป
      </span>
      <i
        v-else-if="!isUpload && !deletable"
        class="fas fa-chevron-right doc-type-chevron"
        aria-hidden="true"
      ></i>
    </button>
    <button
      v-if="deletable && !isGenerating"
      type="button"
      class="doc-type-delete"
      :title="`ลบ ${title}`"
      :aria-label="`ลบ ${title}`"
      @click.stop="handleDelete"
    >
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
/** One document the clinic can create, or a clinic form to sign, as a row button. */
export default {
  name: "DocumentTypeCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    // แบบฟอร์มคลินิกส่ง mediaFile id ที่เป็น Number มา ส่วนเอกสารที่ generate
    // จากโค้ดส่ง key ที่เป็น String
    value: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isGenerating: {
      type: Boolean,
      default: false,
    },
    isUpload: {
      type: Boolean,
      default: false,
    },
    // แสดงปุ่ม × สำหรับลบ — ผู้เรียกเป็นคนตัดสินสิทธิ์
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleGenerate() {
      if (!this.disabled && !this.isGenerating) {
        this.$emit("generate", this.value);
      }
    },
    handleDelete() {
      this.$emit("delete", this.value);
    },
  },
  emits: ["generate", "delete"],
};
</script>

<style scoped>
.doc-type {
  position: relative;
  display: flex;
  align-items: stretch;
  min-width: 0;
}
.doc-type-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 42px;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0 0.75rem;
  border: 0;
  border-radius: 12px;
  background: #f6f7f9;
  color: #101828;
  font-size: 0.875rem;
  text-align: left;
  transition: background 0.15s;
}
.doc-type-main:hover:not(:disabled) {
  background: #eef5fe;
}
.doc-type-main:disabled {
  cursor: not-allowed;
}
.doc-type-icon {
  width: 16px;
  text-align: center;
}
.doc-type-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doc-type-chevron {
  font-size: 0.6875rem;
  color: #9aa2b1;
}
.doc-type.is-locked .doc-type-main {
  background: #fafbfc;
}
.doc-type.is-locked .doc-type-title,
.doc-type.is-locked .doc-type-icon {
  color: #5d6679;
}
.doc-type-lock {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  background: #fff4db;
  color: #7a4b00;
  font-size: 0.6875rem;
  font-weight: 600;
}
.doc-type.is-upload .doc-type-main {
  border: 1.5px dashed #cfd4dd;
  background: #fafbfc;
  color: var(--primary, #0b63c5);
  font-weight: 500;
}
.doc-type.is-upload.is-locked .doc-type-main {
  color: #5d6679;
}
.doc-type-delete {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 15px;
  background: transparent;
  color: #5d6679;
  opacity: 0;
}
.doc-type:hover .doc-type-delete,
.doc-type-delete:focus-visible {
  opacity: 1;
}
.doc-type-delete:hover {
  background: #fdf0ee;
  color: #b42318;
}
.doc-type.has-delete .doc-type-main {
  padding-right: 2.5rem;
}
@media (hover: none) {
  .doc-type-delete {
    opacity: 1;
  }
}
</style>
